export default __webpack_public_path__ + "static/media/20dca8328beef0e3a53dc78ea970aa7b.svg";